import React, { CSSProperties } from "react";
import { Link } from "react-router-dom";
import tdcWhiteLogo from "../../assets/tdc-white-logo.svg";
import landerWindow from "../../assets/lander-window.png";
import { RegisterForm } from "./components";

const FONT = "Lato, sans-serif";

const pageStyle: CSSProperties = {
    fontFamily: FONT
};

const leftPanelStyle: CSSProperties = {
    paddingTop: "160px",
    paddingBottom: "70px",
    paddingLeft: "90px",
    paddingRight: "90px"
};

const headingStyle: CSSProperties = {
    fontFamily: FONT,
    fontWeight: 400,
    fontSize: "20px",
    lineHeight: "100%",
    letterSpacing: 0
};

const footerLinksStyle: CSSProperties = {
    fontFamily: FONT,
    fontWeight: 300,
    fontSize: "12px",
    lineHeight: "100%"
};

const rightPanelStyle: CSSProperties = {
    backgroundColor: "#1a2238",
    paddingTop: "120px",
    paddingLeft: "86px",
    paddingRight: 0,
    paddingBottom: 0,
    position: "sticky",
    top: 0,
    alignSelf: "flex-start",
    height: "100vh"
};

const rightPanelTextStyle: CSSProperties = {
    paddingRight: "86px"
};

const breadcrumbStyle: CSSProperties = {
    fontFamily: FONT,
    fontWeight: 400,
    fontSize: "15px",
    lineHeight: "100%",
    letterSpacing: 0
};

const headlineStyle: CSSProperties = {
    fontFamily: FONT,
    fontWeight: 800,
    fontSize: "clamp(28px, 2.6vw, 40px)",
    lineHeight: "1.1",
    letterSpacing: 0,
    whiteSpace: "nowrap"
};

const subtitleStyle: CSSProperties = {
    fontFamily: FONT,
    fontWeight: 400,
    fontStyle: "italic",
    fontSize: "clamp(16px, 1.2vw, 16px)",
    lineHeight: "1.45",
    letterSpacing: 0,
    maxWidth: "600px"
};

const landerImageStyle: CSSProperties = {
    position: "absolute",
    bottom: "-50px",
    right: "-80px",
    width: "95%",
    maxWidth: "none",
    height: "auto",
    transform: "rotate(-8deg)",
    transformOrigin: "center center",
    pointerEvents: "none"
};

export function RegisterPage() {
    return (
        <div className="min-h-screen w-screen flex flex-col lg:flex-row" style={pageStyle}>
            <div className="w-full lg:w-2/5 bg-black flex flex-col items-center" style={leftPanelStyle}>
                <div className="w-full flex flex-col items-center">
                    <img src={tdcWhiteLogo} alt="The Desire Company" className="w-[200px] mb-6" />
                    <h1 className="text-white mb-6 text-center" style={headingStyle}>
                        Register Your Brand
                    </h1>

                    <RegisterForm />

                    <div className="flex gap-6 mt-5 text-white/70" style={footerLinksStyle}>
                        <Link to="/login" className="hover:text-white transition-colors">
                            Log in
                        </Link>
                        <Link to="/experts/apply" className="hover:text-white transition-colors">
                            Expert Registration
                        </Link>
                    </div>
                </div>
            </div>

            <div
                className="hidden lg:flex w-3/5 flex-col justify-start overflow-hidden relative"
                style={rightPanelStyle}
            >
                <div style={rightPanelTextStyle}>
                    <p className="text-white mb-5 uppercase" style={breadcrumbStyle}>
                        CREATE &rarr; MATCH &rarr; OPTIMIZE &rarr; ACTIVATE &rarr; MANAGE
                    </p>
                    <h2 className="text-white mb-5" style={headlineStyle}>
                        From Expert Match to Market Impact
                    </h2>
                    <p className="text-white/85" style={subtitleStyle}>
                        A complete platform to produce expert-led product videos, make them AI and agent ready, and
                        deploy them across PDP, retail media, and CTV, all from one place.
                    </p>
                </div>
                <div className="flex-1" />
                <img
                    src={landerWindow}
                    alt="The Desire Company portal"
                    className="select-none"
                    style={landerImageStyle}
                />
            </div>
        </div>
    );
}
